import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {LoginService} from '../service/login.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private loginService: LoginService) {
    }

    canActivate(activeRoute: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): boolean {
        const logado = this.loginService.usuarioLogado();
        if (!logado) {
            if (routerState.url.includes("login")) {
                return true;
            }
            if (routerState.url.includes("privacidade")) {
                return true;
            }
            this.loginService.redirectLogin('login');
        } else {
            if (routerState.url.includes("login")) {
                this.loginService.redirectToHome();
            }
            return logado;
        }
    }
}
